// The features a signed-in person can land on, in sidebar order. Used by the landing
// page (which feature to open, or which cards to show) and the no-access page (which
// Entra group to ask for). Platforms is listed for its group name; the landing page
// treats it specially (it renders the platform dashboard, not a card).
import { TIERS } from './roles';

export const FEATURE_HOMES = [
  { key: 'platforms', label: 'Platforms', path: '/m365', tier: TIERS.PLATFORMS, group: 'DB-Platforms',
    blurb: 'Microsoft 365, Sophos, Acronis, Autotask, ScalePad and Datto for every customer.' },
  { key: 'agents', label: 'Agents', path: '/agents', tier: TIERS.AGENTS_HUB, group: 'DB-Agent-AuditRequest, DB-Agent-TSA, DB-Agent-Tender or DB-Engineer-Performance',
    blurb: 'Audit Request, TSA Review, Tender and Engineer Performance agents.' },
  { key: 'reports', label: 'Reports', path: '/reports', tier: TIERS.REPORTS, group: 'DB-Reports',
    blurb: 'Security reports, scans and recommendations.' },
  { key: 'engineer-performance', label: 'Engineer Performance', path: '/engineer-performance', tier: TIERS.ENGINEER_PERFORMANCE, group: 'DB-Engineer-Performance',
    blurb: 'The engineer leaderboard.' },
  { key: 'onboarding', label: 'Customer Onboarding', path: '/onboarding', tier: TIERS.ONBOARDING, group: 'DB-Onboarding',
    blurb: 'Bring a new customer into IT Glue from their documents.' },
  { key: 'walk-round', label: 'OD1N Walk-Round', path: '/walk-round', tier: TIERS.WALKROUND, group: 'DB-WalkRound',
    blurb: 'Capture a site walk-round on a tablet.' },
  { key: 'reconcile', label: 'Invoice Reconcile', path: '/accounts/reconcile', tier: TIERS.RECONCILE, group: 'DB-Reconcile',
    blurb: 'Reconcile supplier invoices against Autotask contracts.' },
  { key: 'management', label: 'Management', path: '/management', tier: TIERS.MANAGEMENT, group: 'SMT Tracking',
    blurb: 'Management actions, meetings and sign-off.' },
];

// The homes a person can open, excluding Platforms (the landing page handles that one).
export function homesFor(hasAnyRole) {
  return FEATURE_HOMES.filter((h) => h.key !== 'platforms' && hasAnyRole(h.tier));
}
